module.exports = __webpack_public_path__ + "img/banner_4.8995ff66.jpg";